import React, { FC } from 'react';
import { DomotzRtd, DomotzRtdentry } from '../../interfaces/NetworkDevices';
import ListComponent from '../../utils/ListComponent';
import { DateUtil } from '../../utils/dates/DateUtil';
import Table from './Table';
import TableItem from './TableItem';
import TableRow from './TableRow';

interface props {
  history: DomotzRtdentry[];
}

const tableHeader = [
  'Time',
  'Min Latency',
  'Median Latency',
  'Max Latency',
  'Sent Packets',
  'Lost Packets',
  'Packet Loss',
];

const NetworkRtdTable: FC<DomotzRtd> = ({ history }) => {
  const maxLatencyNumber = 15;
  const badLatencyNumber = 10;
  return (
    <div>
      <Table header={tableHeader}>
        <ListComponent
          data={history}
          renderItem={(item, index) => (
            <TableRow key={index}>
              <TableItem>{DateUtil.timeStampToBE(item.timestamp)}</TableItem>
              <TableItem>{item.min}ms</TableItem>
              <TableItem>{item.median}ms</TableItem>
              <TableItem>
                <span
                  className={`${
                    item.max > maxLatencyNumber
                      ? 'text-red-500 font-extrabold'
                      : item.max > badLatencyNumber
                        ? 'text-yellow-400 font-bold'
                        : ''
                  }`}
                >
                  {item.max}ms
                </span>
              </TableItem>
              <TableItem>{item.sent_packet_count}</TableItem>
              <TableItem>{item.lost_packet_count}</TableItem>
              <TableItem>{item.lost_packet_count}</TableItem>
            </TableRow>
          )}
        />
      </Table>
    </div>
  );
};

export default NetworkRtdTable;
